// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import GridController from "./grid_controller"
application.register("grid", GridController)

import IndustryController from "./industry_controller"
application.register("industry", IndustryController)

import LanguageSelectorController from "./language_selector_controller"
application.register("language-selector", LanguageSelectorController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LocationFilterController from "./location_filter_controller"
application.register("location-filter", LocationFilterController)

import MapController from "./map_controller"
application.register("map", MapController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SlimController from "./slim_controller"
application.register("slim", SlimController)

import SubIndustryController from "./sub_industry_controller"
application.register("sub-industry", SubIndustryController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import WidgetController from "./widget_controller"
application.register("widget", WidgetController)

import ZendeskChatController from "./zendesk_chat_controller"
application.register("zendesk-chat", ZendeskChatController)
